import { render, staticRenderFns } from "./AdminUsersLoginHistory.vue?vue&type=template&id=3b2ddec5&"
import script from "./AdminUsersLoginHistory.vue?vue&type=script&lang=js&"
export * from "./AdminUsersLoginHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports